import { Component } from '@verndale/core';
import { constEvent } from '../utils/constants';
import SlimSelectComponent from '../components/slim-select';
import _find from 'lodash/find';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.id;

    this.dom = {
      $el: this.el,
      $select: this.el._$$('select')
    };

    this.setup();
  }

  addListeners() {
    document.addEventListener(constEvent.CONTACT_FORM_UPDATED, () => {
      this.setup();
    });
  }

  setup() {
    this.dom.$select.forEach(dropdown => {
      const $slimSelect = dropdown.nextElementSibling;
      const isSlimSelectInited = $slimSelect.classList.contains('ss-main');
      if ($slimSelect && isSlimSelectInited && dropdown.disabled) {
        $slimSelect.classList.add('disabled');
        dropdown.slim.disable();
      } else if ($slimSelect && isSlimSelectInited && !dropdown.disabled) {
        $slimSelect.classList.remove('disabled');
        dropdown.slim.enable();
      }

      if (!isSlimSelectInited) {
        new SlimSelectComponent(dropdown);
      }

      dropdown.style.display = 'block';
      dropdown.style.position = 'absolute';
      dropdown.style.height = '0';
      dropdown.style.opacity = '0';
    });
  }

}

export default Module;
